import Backbone from 'backbone';

import EmptySetView from '@/views/EmptySetView';

import WideFormatSummaryView from '../../forms/SummaryFormView/WideFormatSummaryView/WideFormatSummaryView';
import VB0SummaryView from '../../forms/SummaryFormView/VB0SummaryView/VB0SummaryView';
import VB0v3SummaryView from '../../forms/SummaryFormView/VB0v3SummaryView/VB0v3SummaryView';
import DesktopSummaryView from '../../forms/SummaryFormView/DesktopSummaryView/DesktopSummaryView';
import PRTNRSummaryView from '../../forms/SummaryFormView/PRTNRSummaryView/PRTNRSummaryView';
import MaintenanceSummaryView from '../../forms/SummaryFormView/MaintenanceSummaryView/MaintenanceSummaryView';
import MFDSummaryView from '../../forms/SummaryFormView/MFDSummaryView/MFDSummaryView';
import SpecialtyRequirementSummaryView from '../../forms/SummaryFormView/SpecialtyRequirementSummaryView/SpecialtyRequirementSummaryView';
import RelocationSummaryView from '../../forms/SummaryFormView/RelocationSummaryView/RelocationSummaryView';
import DefaultSummaryView from '../../forms/SummaryFormView/DefaultSummaryView/DefaultSummaryView';
import OrderAccess from '../../utils/OrderAccess';

import SubmittableOrderView from '../SubmittableOrderView/SubmittableOrderView';


import tmplOrderSummaryView from './OrderSummaryView.hbs';

const OrderSummaryView = SubmittableOrderView.extend({
  template: tmplOrderSummaryView,

  className: 'order-summary-view',

  ui: {
    summarySection: '.order-summary'
  },

  regions: {
    summarySection: '@ui.summarySection'
  },

  onRender() {
    switch (this.model.get('orderDetails').orderTypeId) {
      case '1':
      case '3':
        this.showChildView(
          'summarySection',
          new MFDSummaryView({
            model: new Backbone.Model({
              order: this.model.get('order')
            })
          })
        );
        break;

      case '2':
      case '13':
      case '14':
      case '15':
        this.showChildView(
          'summarySection',
          new PRTNRSummaryView({
            model: new Backbone.Model({
              order: this.model.get('order'),
              orderTotals: this.model.get('orderTotals')
            })
          })
        );
        break;

      case '4':
        this.showChildView(
          'summarySection',
          new MaintenanceSummaryView({
            model: new Backbone.Model({
              order: this.model.get('order')
            })
          })
        );
        break;

      case '5':
        this.showChildView(
          'summarySection',
          new WideFormatSummaryView({
            model: new Backbone.Model({
              order: this.model.get('order')
            })
          })
        );
        break;

      case '6':
      case '10':
      case '11':
        this.showChildView(
          'summarySection',
          new DesktopSummaryView({
            model: new Backbone.Model({
              order: this.model.get('order')
            })
          })
        );
        break;

      case '12':
        this.showChildView(
          'summarySection',
          new RelocationSummaryView({
            model: new Backbone.Model({
              order: this.model.get('order')
            })
          })
        );
        break;

      case '16':
      case '18':
        this.showChildView(
          'summarySection',
          new VB0SummaryView({
            model: new Backbone.Model({
              order: this.model.get('order')
            })
          })
        );
        break;

      case '17':
        this.showChildView(
          'summarySection',
          new WideFormatSummaryView({
            model: new Backbone.Model({
              order: this.model.get('order')
            })
          })
        );
        break;

      case '20':
      case '21':
        this.showChildView(
          'summarySection',
          new VB0v3SummaryView({
            model: new Backbone.Model({
              order: this.model.get('order')
            })
          })
        );
        break;
      
      case '22':
      case '23':
      case '24':
      case '25':
      case '26':
        this.showChildView(
          'summarySection',
          new DefaultSummaryView({
            model: new Backbone.Model({
              order: this.model.get('order'),
              orderTypeId: this.model.get('orderDetails').orderTypeId
            })
          })
        );
      break;

      case '19':
        this.showChildView(
          'summarySection',
          new SpecialtyRequirementSummaryView({
            model: new Backbone.Model({
              order: this.model.get('order'),
              isPriceVisible: OrderAccess.isPriceVisible(this.model.get('orderDetails').orderDetails)
            })
          })
        );
        break;

      default:
        this.showChildView(
          'summarySection',
          new EmptySetView({
            emptyText: 'Order summary data not available for migrated orders.'
          })
        );
        break;
    }
  },

  validate() {
    return;
  }
});

export default OrderSummaryView;
